import {
    SET_ASSET_EONE_DETAILS,
    SET_ASSET_AUDIT_REPORT_DETAILS
} from "./AssetEoneDetailsType";

const initialState = {
    assetEoneDetails: null
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_EONE_DETAILS:
            return {
                ...state,
                assetEoneDetails: action.assetEoneDetails,
            };
        default:
            return state;
    }
}

export default reducers